import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
    size?: number;
    message?: string;
    fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 40,
    message,
    fullScreen = false,
}) => {
    const { t } = useTranslation();
    const content = (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                ...(fullScreen && {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    zIndex: 9999,
                }),
            }}
        >
            <CircularProgress size={size} />
            <Typography variant="body2" color="text.secondary">
                {message || t('common.loading')}
            </Typography>
        </Box>
    );

    return content;
};

export default LoadingSpinner; 